import HNSColors from "../../../../HNSColors";

const HisArrowDown = ({ color, sx }) => {
  const strokeColor = color ?? HNSColors.failure[500];
  const _sx = sx ?? {};
  return (
    <svg
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={_sx}
    >
      <path
        stroke={strokeColor}
        d="M10.3218 12.4095C9.75789 13.1851 8.60148 13.1851 8.03752 12.4095L0.810512 2.4708C0.131757 1.53737 0.798547 0.228066 1.95267 0.228066L16.4067 0.228065C17.5608 0.228065 18.2276 1.53737 17.5489 2.4708L10.3218 12.4095Z"
        fill={strokeColor}
      />
    </svg>
  );
};

export default HisArrowDown;
